import { useUser } from 'shared/hooks';
import { ProductsPage } from './products-page';

export function ProductsResolver() {
  const user = useUser();

  if (!user) {
    return null;
  }

  return <ProductsPage user={user} />;
}
